const $ = window.jQuery;
$(() => {

    const singelCartButton = $('.single_add_to_cart_button');
    singelCartButton.on('click', function (e) {
        e.preventDefault();
        $('#loader').show(400, function () {
            singelCartButton.closest('form').submit();
        });
    });


    $('.wc-pao-addon-foto-upload .form-row small').text('max. Dateigröße 32 MB');

    $.fn.modal = function (options) {
        var settings = $.extend({
            fullsize: false
        }, options);

        $("[data-modal]").on("click", function () {
            const modal = $(this).attr("data-modal");
            console.log('Click Modal Link')

            if (settings.fullsize) {
                $("#" + modal).addClass('fullsize');
            }

            $("#" + modal).fadeIn();
        });

        $(".modal").on("click", function (e) {
            const target = e.target;
            if ($(target).hasClass("modal-close") ||
                $(target).hasClass("modal-overlay")) {
                $(target).parent().fadeOut();
            }
        });
    }

    $("#modal").modal({
        //fullsize: true
    });
});